export default "__VITE_ASSET__DB2sErZv__"